import { FBProcedureProps, FBProcedureValue, FBProviderProps } from '..';

// `type` is absent on old snapshots (procedure-only) and 'mpiprocedure' on new ones; anything else is a cloned
// MPI component whose own value is kept in `value` and rendered via FBSchemaState.component.
export type FBDeviationStepValue = FBProcedureValue & {
  stepIndex?: number
  mpiIndex?: number
  type?: string
  label?: string
  value?: unknown
  added?: boolean // component added in the deviation itself (not cloned from the MPI)
  schemaItem?: Record<string, unknown> // full MPI schema item (type, label, editorConfig, validators, ...)
};

export const isDeviationProcedureStep = (step?: FBDeviationStepValue): boolean =>
  !step?.type || step.type === 'mpiprocedure';

export interface FBDeviationEditorConfig {
  [mpiId: string]: { [stepId: string]: FBDeviationStepValue }
}

export type FBDeviationProcedureProps =
  & Omit<FBProcedureProps, 'procedureState'>
  & Pick<FBProviderProps, 'deviationProcedureState'>
  & {
    editorConfig?: FBDeviationEditorConfig
    redlineActive?: boolean
    canEdit?: boolean
  };
